<script>
export default {
  name: 'AppCheckbox',
  props: {
    value: {},
    size: { type: [Number, String], default: 18 },
    variant: { type: String, default: 'default' }
  },
  methods: {
    checkChanged(e) {
      this.$emit('input', e.target.checked);
    }
  }
};
</script>

<template>
  <label class="app-checkbox" :class="`app-checkbox--${variant}`" :style="{ '--checkbox-size': `${size}px` }">
    <input type="checkbox" :checked="value" @change="checkChanged" />
    <span class="icon">
      <ion-icon name="checkbox" class="checkbox"></ion-icon>
      <ion-icon class="square-outline" name="square-outline"></ion-icon>
    </span>
    <span v-if="$slots.default" class="slot-label">
      <slot></slot>
    </span>
  </label>
</template>
